import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {IOSFullscreenModule} from '@gongxigames/framework/slot/modules/iOSFullscreen/IOSFullscreenModule';
import {IOSFullscreenModuleStates} from '@gongxigames/framework/slot/modules/iOSFullscreen/IOSFullscreenModule';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';

export class FullscreenState extends ModuleState<null, IOSFullscreenModule> {
    public onEnterState(): void {
    }

    public onLeaveState(): void {}

    protected setupEvents(): void {
        this.setEventHandler('General.Screen.RESIZED', this.screenResized.bind(this));
        strictUiEmitter.on('UI.menu.opened', this.onStrictGotoIdleState.bind(this));
    }

    protected onStrictGotoIdleState(): void {
        if (this.module.currentState?.name === this.name) {
            this.gotoIdleState();
        }
    }

    private screenResized(): void {
        if (!this.module.isFullScreen()) {
            this.module.gotoState(IOSFullscreenModuleStates.NotFullScreen);
        }
    }

    private gotoIdleState(): void {
        this.module.gotoState(IOSFullscreenModuleStates.Idle);
    }
}
